import React from 'react';
import { Cpu, Database, Shield, Server, CheckCircle} from 'lucide-react';
import MissionValueSection from '../missionvalue';
import '../styles/about.css';

const About = () => {
  const features = [
    {
      icon: <Cpu className="feature-icon" />,
      title: "Comprehensive Solutions",
      description: "We offer a wide range of cutting-edge medical equipment and technologies, ensuring you have access to the latest advancements in healthcare."
    },
    {
      icon: <Database className="feature-icon" />,
      title: "Exceptional Service & Support",
      description: "We are committed to exceeding your expectations with our dedicated team always available to assist you, from installation and training to maintenance and repairs."
    },
    {
      icon: <Shield className="feature-icon" />,
      title: "Strong Partnerships",
      description: " We collaborate with leading national and international companies, bringing you the best quality equipment and technologies from around the world."
    },
    {
      icon: <Server className="feature-icon" />,
      title: "Tailored Solutions",
      description: "We understand that every healthcare facility has unique needs. We work closely with you to provide customized solutions that meet your individual goals."
    }
  ];

  const planningItems = [
    "Site Survey & Assessment",
    "Technology Evaluation",
    "Installation Planning",
    "Training & Education",
    "Maintenance & Service Planning",
    "Budget & ROI Analysis"
  ];

  return (
    <>
      <div className="features-container">
        {/* Header Section */}
        <div className="features-header">
          <h1 className="features-title">
            <span className="features-title-light">Why choose </span>
            <span className="features-title-bold">York Engineering?</span>
          </h1>
          <p className="features-description">
          At York Engineering, we are not just suppliers; we are partners in progress. We believe in crafting innovative and efficient solutions that empower healthcare providers in Nepal to deliver the best possible patient care.          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3 className="feature-card-title">
                {feature.title}
              </h3>
              <p className="feature-card-description">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
          <MissionValueSection />
      {/* Planning Section */}
      <div className="planning-container">
        <div className="planning-header">
          <h2 className="planning-title">
            <span className="planning-title-light">Planning & </span>
            <span className="planning-title-bold">strategy</span>
          </h2>
          <p className="planning-description">
          At York Engineering, we understand that implementing new medical technology requires careful planning and a strategic approach. Our team works closely with healthcare providers to ensure a smooth and successful transition.
          </p>
        </div>

        <div className="planning-items">
          {planningItems.map((item, index) => (
            <div key={index} className="planning-item">
              <CheckCircle className="planning-icon" />
              <span className="planning-item-text">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default About;
